import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseFacade } from '@core/classes/base.facade';
import { ContentDto, ContentLongDto, StationDto } from '@api/rest';
import * as fromContent from './_ngrx/content.reducer';
import * as ContentState from './_ngrx/content.selectors'
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { ContentType } from '@app/shared/enums/content-type.enum.ts';

@Injectable()
export class ContentFacade extends BaseFacade {
  private state$: Store<fromContent.State>;


  readonly allContents$: Observable<ContentLongDto[]> = this.takeAll(ContentState.getContents);
  readonly selectedStationContents$: Observable<ContentLongDto[]> = this.takeAll(ContentState.getStationContents);
  readonly selected$: Observable<ContentLongDto> = this.takeAll(ContentState.getSelected);

  constructor() {
    const state$ = inject<Store<fromContent.State>>(Store);

    super(state$);

    this.state$ = state$;
  }

  getContentById(id: string): Observable<ContentDto> {
    return this.allContents$
      .pipe(
        map(contents => contents.find(content => content._id === id))
      );
  }

  getContenstByIds(ids: string[]): Observable<ContentDto[]> {
    return this.allContents$
      .pipe(
        map(contents => contents.filter(content => ids.includes(content._id)))
      );
  }

  getContentForStationByType(station: StationDto, contentType: ContentType) {
    return this.getContenstByIds(station.content_refs)
      .pipe(
        map(contents => contents.filter(content => content.type === contentType))
      );
  }
}
